import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const StorePickup32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight32 : s.svgDark32,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      d="M20.818 17.437l4.566 4.626-2.155.008 1.577 3.902-.927.374-1.578-3.901-1.553 1.49.07-6.5zM15.855 3.52c2.845 0 4.58 2.097 5.305 5.515L28 9.05v9.984A6.5 6.5 0 0016.498 25H4V9l6.554.013c.728-3.405 2.462-5.493 5.301-5.493zM5.5 10.503V23.5h9.062A8 8 0 0126.5 15.57v-5.023l-5.095-.01c.1.852.15 1.766.15 2.733h-1.5a21.4 21.4 0 00-.163-2.738l-8.072-.016c-.11.838-.165 1.758-.165 2.754h-1.5c0-.976.05-1.898.153-2.756l-4.808-.01zM15.855 5.02c-1.867 0-3.138 1.455-3.76 3.996l7.524.016c-.62-2.551-1.894-4.012-3.764-4.012z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default StorePickup32;
